export default __webpack_public_path__ + "static/media/a008-6.c517aa96.svg";